import React from "react";
import FormItem from "../../../molecules/FormItem/FormItem";
import { Form, Formik } from "formik";
import { initialValues } from "./initialValues";
import { driveStyles, enquiryTypes } from "./selects";
import { validationSchema } from "./validationSchema";
import styled from "styled-components";
import { PRIMARY } from "../../../../vars/vars";
import Checkbox from "../../../atoms/Checkbox/Checkbox";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import UniversalModal from "../../UniversalModal/UniversalModal";
import useContactForm from "../../../../hooks/useContactForm";
import { translatedCountries } from "../../../pages/Distributors/dictionaries";

const GeneralForm = () => {
  const recaptchaRef = React.useRef(null);

  const { onSubmit, showModal, modalText, setShowModal } = useContactForm(
    "GENERAL",
    recaptchaRef
  );

  const props = {
    onSubmit,
    initialValues,
    validationSchema,
  };

  return (
    <section>
      <Formik {...props}>
        {(props) => (
          <Form>
            <FormItem label={"Imię"} required name={"firstName"} />
            <FormItem label={"Nazwisko"} required name={"lastName"} />
            <FormItem label={"Email"} required name={"email"} type={"email"} />
            <FormItem
              required
              selectLabel={"Państwo"}
              name={"country"}
              label={"Państwo"}
              select
              items={translatedCountries}
            />
            <FormItem
              required
              selectLabel={"Temat zapytania"}
              name={"typeOfEnquiry"}
              label={"Temat zapytania"}
              select
              items={enquiryTypes}
            />
            {(props.values.typeOfEnquiry === "dontKnow" ||
              props.values.typeOfEnquiry === "know") && (
              <>
                <FormItem
                  select
                  label={"Styl jazdy"}
                  selectLabel={"Styl jazdy"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"driveStyle"}
                  items={driveStyles}
                />
                <FormItem
                  label={"Marka"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"make"}
                />
                <FormItem
                  label={"Model"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"model"}
                />
                <FormItem
                  label={"Rocznik"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"year"}
                />
                <FormItem
                  label={"Pojemność silnika"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"engine"}
                />
                <FormItem
                  label={"Dodatkowa waga na przedzie"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"extraFront"}
                />
                <FormItem
                  label={"Dodatkowa waga na tyle"}
                  required={props.values.typeOfEnquiry === "dontKnow"}
                  name={"extraRear"}
                />
              </>
            )}
            {props.values.typeOfEnquiry === "know" && (
              <FormItem label={"Numer części"} required name={"part"} />
            )}
            <FormItem
              label={"Treść wiadomości"}
              textarea
              required
              name={"message"}
            />
            <Checkbox name={"privacy"}>
              Akcpetuję{" "}
              <StyledLink to={"/privacy"}>Politykę prywatności</StyledLink>
            </Checkbox>
            {showModal && (
              <UniversalModal
                text={modalText}
                clickHandler={() => setShowModal(false)}
              />
            )}
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey="6LenKrEUAAAAAE1bjyJeZ563lCnEG29Y0sEyBhp3"
            />
            <StyledButton type={"submit"}>Wyślij</StyledButton>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default GeneralForm;

const StyledButton = styled.button`
  margin: 20px 0;
  display: block;
  padding: 10px 20px;
  background: #292b29;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.1s ease;
  white-space: nowrap;

  &:hover {
    background-color: ${PRIMARY};
  }
`;

const StyledLink = styled(Link)`
  font-weight: 600;

  &:hover {
    color: ${PRIMARY};
    cursor: pointer;
  }
`;
